import React, { ReactElement } from 'react';
import { Tags } from '@tryghost/helpers-gatsby';
import { IPost } from 'src/utils/ts/blog';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import {
  LinkWrapper,
  ItemCard,
  TagsWrapper,
  Details,
  Title,
  Excerpt,
} from './styles';

interface IPostCard {
  post: IPost;
}

const PostCard = ({ post }: IPostCard): ReactElement => {
  const url = `/blog/${post.slug}/`;

  return (
    <Col lg="4">
      <LinkWrapper to={url}>
        <ItemCard>
          {post.feature_image && (
            <Card.Img variant="top" src={post.feature_image} />
          )}
          <Card.Body>
            {post.tags && (
              <TagsWrapper>
                <Tags
                  post={post}
                  visibility="public"
                  autolink={false}
                  separator=" | "
                />
              </TagsWrapper>
            )}
            <Details>
              on {post.published_at_pretty} / by{' '}
              {post.primary_author.name}
            </Details>
            <Title>{post.title}</Title>
            <Excerpt>{post.excerpt}</Excerpt>
          </Card.Body>
        </ItemCard>
      </LinkWrapper>
    </Col>
  );
};

export default PostCard;
